import * as types from './types'
import storage from '@/Plugins/storage'
import moment from 'moment'
import globals from '@/Plugins/globals'
import store from '@/Store'
import { measurements } from '../UserMeasurements'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.SET_STARLEVEL](state, data) {
    if (state.members) {
      let found = state.members.find(
        (x) => parseInt(x.user_id) === parseInt(data.id)
      )
      if (found) {
        found.starlevel = data.level === 0 ? 1 : 0
        if (state.member) {
          state.member.starlevel = found.starlevel
        }
      }
    }
  },
  [types.SET_UNREAD_MESSAGES](state, data) {
    if (state.members) {
      let found = state.members.find(
        (x) => parseInt(x.user_id) === parseInt(data.data.memberId)
      )
      if (found) {
        found.unread_messages = parseInt(data.count)
      }
    }
  },
  [types.SET_LISTS](state, data) {
    // sets the user-defined Client Lists along
    // with the list of available organization client members
    state.lists = []
    state.clients = []
    if (data !== undefined && data !== null) {
      let last = null
      data.lists.forEach((element) => {
        if (element.id !== last) {
          state.lists.push({
            id: element.id,
            name: element.name,
            isSelected: false,
            clients: [
              {
                id: element.user_id,
                firstname: element.firstname,
                lastname: element.lastname,
                nickname: element.nickname,
                isSelected: 0,
              },
            ],
          })
        } else {
          state.lists[state.lists.length - 1].clients.push({
            id: element.user_id,
            firstname: element.firstname,
            lastname: element.lastname,
            nickname: element.nickname,
            isSelected: 0,
          })
        }
        last = element.id
      })
      state.clients = data.users
    }
    // console.log('Setting List', { lists: state.lists, clients: state.clients })
  },
  [types.RESET_LISTS](state) {
    // just resets the selected (checked)
    state.lists.forEach((list) => {
      list.clients.map((x) => (x.isSelected = 0))
    })
    state.clients.map((x) => (x.isSelected = 0))
  },
  [types.SET_CHECKED_INLIST](state) {
    state.clients.map((x) => (x.isSelected = 0))
    if (state.selectedids) {
      if (state.selectedids.length > 0) {
        state.clients.forEach((element) => {
          let found = state.selectedids.find(
            (x) => parseInt(x.user_id) === parseInt(element.user_id)
          )
          if (found) {
            element.isSelected = 1
          }
        })
      }
    }
  },
  [types.SET_LIST](state, data) {
    // this is used by the Client List dialog, as well as,
    // the Challenge Member List.  So, keep that in mind.
    // console.log('Setting a List', {
    //   lists: state.lists,
    //   data: data,
    // })
    switch (data.name) {
      case 'add': {
        // strictly used by Client List dialog
        // this adds a new user-created list item
        let found = state.lists.find(
          (x) => x.name.toUpperCase() === data.value.name.toUpperCase()
        )
        if (found === undefined || found === null) {
          state.lists.push(data.value)
        }
        break
      }
      case 'remove': {
        // strictly used by Client List dialog
        // this removes a user-create list item
        state.lists = state.lists.filter((el) => {
          return el.id !== data.value
        })
        break
      }
      case 'addClient': {
        // strictly used by Client List dialog
        // it looks through the user-created lists to find newly
        // selected (checked) client members
        let found = state.lists.find(
          (x) => x.name.toUpperCase() === data.listName.toUpperCase()
        )
        if (found) {
          let selected = state.clients.filter((el) => {
            return el.isSelected === 1
          })
          selected.forEach((element) => {
            let there = found.clients.find((x) => x.id === element.user_id)
            if (there === undefined || there === null) {
              found.clients.push({
                id: element.user_id,
                firstname: element.firstname,
                lastname: element.lastname,
                nickname: element.nickname,
                isSelected: 0,
              })
            }
          })
          state.clients.map((x) => (x.isSelected = 0))
        }
        break
      }
      case 'removeClient': {
        // strictly used by Client List dialog
        // this removes client member(s) from the List clients
        let found = state.lists.find(
          (x) => x.name.toUpperCase() === data.listName.toUpperCase()
        )
        if (found) {
          found.clients = found.clients.filter((el) => {
            return el.isSelected === 0
          })
        }
        break
      }
      case 'currentSelected': {
        state.selected = JSON.parse(JSON.stringify(data.members))
        break
      }
      case 'addSelected': {
        // this is used by the Challenge Member list
        // it adds selected (checked) client members to the
        // Challenge Member list
        let selected = state.clients.filter((el) => {
          return el.isSelected === 1
        })
        selected.forEach((element) => {
          let there = state.selected.find((x) => x.id === element.id)
          if (there === undefined || there === null) {
            state.selected.push(JSON.parse(JSON.stringify(element)))
          }
        })
        break
      }
      case 'removeSelected': {
        // this is used by the Challenge Member list
        // it removes selected (checked) members from the list
        state.selected = state.selected.filter((el) => {
          return el.isSelected === 0
        })
        break
      }
      case 'select-list': {
        // this is used by both the Client List Dialog
        // it turns on/off the check box
        let found = state.lists.find(
          (x) => x.name.toUpperCase() === data.listName.toUpperCase()
        )
        if (found) {
          let selected = found.clients.find((x) => x.id === data.value)
          if (selected) {
            selected.isSelected = selected.isSelected === 0 ? 1 : 0
          }
        }
        break
      }
      case 'select-client': {
        // this is used by both the Client List Dialog and the Challenge Member list
        // it turns on/off the check box in the available Client list
        let found = state.clients.find((x) => x.user_id === data.value)
        if (found) {
          found.isSelected = found.isSelected === 0 ? 1 : 0
        }
        break
      }
      case 'select-selected': {
        // this is used by the Challenge Member list
        // it turns on/off the check box
        let found = state.selected.find((x) => x.id === data.value)
        if (found) {
          found.isSelected = found.isSelected === 0 ? 1 : 0
        }
        break
      }
      case 'reset-client': {
        // this is used by both the Client List Dialog and the Challenge Member list
        // resets selected
        state.clients.map((x) => (x.isSelected = 0))
        break
      }
      case 'reset-selected': {
        // this is used by the Challenge Member list
        // resets selected
        state.selected.map((x) => (x.isSelected = 0))
        break
      }
      case 'init-selected': {
        // this is used by the Challenge Member list
        // initializes the selected list
        state.selected = []
      }
    }
    // console.log('Set a List', { lists: state.lists, clients: state.clients })
  },
  [types.UPDATE_CUSTOM_VIEW](state, data) {
    state.selectedView = {
      name: '',
      columns: [],
    }
    if (state.customViews === undefined || state.customViews === null) {
      state.customViews = []
      state.customViews.push({
        name: data.name,
        columns: [],
      })
    } else {
      if (data.action === 'add') {
        let found = state.customViews.find(
          (x) => x.name.toUpperCase() === data.name.toUpperCase()
        )
        if (found === undefined || found === null) {
          state.customViews.push({
            name: data.name,
            columns: [],
          })
          state.selectedView.name = data.name
        } else {
          state.selectedView.name = found.name
          state.selectedView.columns = found.columns
        }
      } else if (data.action === 'remove') {
        state.customViews = state.customViews.filter((el) => {
          return el.name.toUpperCase() !== data.name.toUpperCase()
        })
      }
    }
    storage.local.setItem(
      types.STORE_SELECTEDVIEW,
      JSON.stringify(state.selectedView)
    )
  },
  [types.RESET_SELECTED_VIEW](state) {
    state.selectedView = {
      name: '',
      columns: [],
    }
    storage.local.setItem(
      types.STORE_SELECTEDVIEW,
      JSON.stringify(state.selectedView)
    )
  },
  [types.SET_SELECTED_VIEW](state, data) {
    state.selectedView = {
      name: '',
      columns: [],
    }
    if (data !== undefined && data !== null) {
      if (data.name != '') {
        if (data.isAdd) {
          state.selectedView = {
            name: data.name,
            columns: [],
          }
        } else {
          let view = state.customViews.find(
            (x) => x.name.toUpperCase() === data.name.toUpperCase()
          )
          if (view) {
            state.selectedView = {
              name: view.name,
              columns: view.columns,
            }
          }
        }
      }
    }
    storage.local.setItem(
      types.STORE_SELECTEDVIEW,
      JSON.stringify(state.selectedView)
    )
  },
  [types.SET_CUSTOM_VIEWS_CONFIG](state, data) {
    state.customViews = []
    if (data !== undefined && data !== null) {
      if (data.TextValue) {
        state.customViews = JSON.parse(data.TextValue)
      }
    }
  },
  [types.SET_CUSTOM_VIEWS](state, data) {
    // got Custom View data from API Services
    state.customViews = []
    if (data !== undefined && data !== null) {
      state.customViews = JSON.parse(data.Value)
      console.log('Got Custom Views', state.customViews)
    }
  },
  [types.SET_CUSTOM_COLUMN](state, data) {
    let len = 0
    let idx = 0
    var current = null
    var previous = null
    var next = null
    let change = 0
    console.log('Setting Column', { views: state.customViews, data: data })
    if (state.customViews !== undefined && state.customViews !== null) {
      let view = state.customViews.find(
        (x) => x.name.toUpperCase() === data.view.toUpperCase()
      )
      if (view !== undefined && view !== null) {
        switch (data.name) {
          case 'add': {
            if (data.value) {
              let found = view.columns.find(
                (x) => x.name.toUpperCase() === data.value.name.toUpperCase()
              )
              if (found === undefined || found === null) {
                view.columns.push(data.value)
              }
            }
            break
          }
          case 'remove': {
            view.columns = view.columns.filter((el) => {
              return el.name.toUpperCase() !== data.value.name.toUpperCase()
            })
            break
          }
          case 'sort': {
            len = view.columns.length
            idx = view.columns
              .map((e) => {
                return e.id
              })
              .indexOf(data.value)
            current = view.columns[idx]
            previous = view.columns[(idx + len - 1) % len]
            next = view.columns[(idx + 1) % len]
            change = 0
            if (data.direction === 'up') {
              change = previous.sort
              previous.sort = current.sort
              current.sort = change
              if (current.sort === previous.sort) {
                current.sort++
              }
            } else {
              change = next.sort
              next.sort = current.sort
              current.sort = change
              if (current.sort === next.sort) {
                next.sort++
              }
            }
            view.columns = globals.sortArray(view.columns, 'sort', 'asc')
            break
          }
        }
        state.selectedView = {
          name: view.name,
          columns: view.columns,
        }
        storage.local.setItem(
          types.STORE_SELECTEDVIEW,
          JSON.stringify(state.selectedView)
        )
      }
    }
  },
  [types.SET_FILTER](state, data) {
    switch (data.name) {
      case 'filterAs': {
        state.filter.filterAs = data.value
        break
      }
      case 'range-limit': {
        state.filter.range.limit = data.value
      }
      case 'range-min': {
        state.filter.range.min = data.value
        break
      }
      case 'range-max': {
        state.filter.range.max = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_FILTER, JSON.stringify(state.filter))
    console.log('Set Filter', state.filter)
  },
  [types.SET_SUMMARY](state, data) {
    state.summary = null
    if (data !== undefined && data !== null) {
      state.summary = data
      state.summary.isChanged = false
      let found = state.columns.find((x) => x.code === 'NutritionHabits')
      if (found) {
        if (data.habit) {
          found.name = data.habit.name
        }
      }
    }
    console.log('Manage Members Summary', {
      summary: state.summary,
      columns: state.columns,
    })
  },
  [types.SET_LIBRARYNAME](state, data) {
    state.summary.organization.libraryName = data
    state.summary.isChanged = true
    console.log('Set Library Name', state.summary)
  },
  [types.SET_CHALLENGENAME](state, data) {
    state.summary.organization.challengeName = data
    state.summary.isChanged = true
    console.log('Set Challenge Name', state.summary)
  },
  [types.SET_DASHBOARDNAME](state, data) {
    state.summary.organization.dashboardName = data
    state.summary.isChanged = true
    console.log('Set Dashboard Name', state.summary)
  },
  [types.RESET_WEEK](state, data) {
    state.summary.week = state.summary.weekCoach
    state.summary.isChanged = false
  },
  [types.SET_WEEK](state, data) {
    if (data.isDir) {
      console.log('Week: Next/Previous', data)
      let idx = state.summary.weeks.findIndex((week) => {
        if (week.short === data.week) {
          return true
        }
      })
      let newIdx = idx + data.increment
      if (newIdx >= 0 && newIdx < state.summary.weeks.length) {
        state.summary.week = {
          name: state.summary.weeks[newIdx].short,
          value: moment(state.summary.weeks[newIdx].date.date).format(
            'YYYY-MM-DD'
          ),
        }
        if (data.isCoach) {
          state.summary.weekCoach = {
            name: state.summary.weeks[newIdx].short,
            value: moment(state.summary.weeks[newIdx].date.date).format(
              'YYYY-MM-DD'
            ),
          }
        }
      }
    } else {
      console.log('Week: Select', data)
      let found = state.summary.weeks.find((x) => x.short === data.week)
      if (found !== null) {
        state.summary.week = {
          name: found.short,
          value: moment(found.date.date).format('YYYY-MM-DD'),
        }
        if (data.isCoach) {
          state.summary.weekCoach = {
            name: found.short,
            value: moment(found.date.date).format('YYYY-MM-DD'),
          }
        }
      }
    }
    state.summary.isChanged = true
  },
  [types.SET_MEMBER_DATA](state, data) {
    switch (data.name) {
      case 'height': {
        state.member.height = data.value
        break
      }
      case 'weight': {
        state.member.weight = data.value
        break
      }
      case 'gender': {
        state.member.gender = data.value
        break
      }
      case 'birthday': {
        state.member.dateOfBirth = data.value
        break
      }
      case 'role': {
        state.member.currentRole = data.value
        break
      }
      case 'allowTexts': {
        state.member.allowTextMessages = data.value
        break
      }
    }
  },
  [types.SET_MEMBERIDS_DIRECT](state, data) {
    state.memberids = data
  },
  [types.SET_MEMBERIDS](state, data) {
    state.memberids = null
    if (data !== undefined && data !== null) {
      // do we have any checked members?
      console.log('Set Member IDs', {
        data: data.data,
        isAll: state.isAllChecked,
        selectedIds: state.selectedids,
        unselectedIds: state.unselectedids,
      })
      state.memberids = data.data
      if (state.selectedids && !state.isAllChecked) {
        if (state.selectedids.length > 0) {
          // if so, replace the data with those
          state.memberids = []
          state.selectedids.forEach((element) => {
            state.memberids.push({
              user_id: element.user_id,
              FirstName: element.FirstName,
              LastName: element.LastName,
            })
          })
        } else if (!state.isAllChecked) {
          state.memberids = []
        }
      } else if (!state.isAllChecked) {
        state.memberids = []
      } else {
        if (state.unselectedids) {
          if (state.unselectedids.length > 0) {
            state.unselectedids.forEach((element) => {
              state.memberids = state.memberids.filter(
                (x) => parseInt(x.user_id) !== parseInt(element.user_id)
              )
            })
          }
        }
      }
      // now, loop through for clean up
      state.memberids.forEach((element) => {
        element.user_id = parseInt(element.user_id)
      })
      // set the recipients (used for email/notifications)
      let recipients = []
      state.memberids.forEach((element) => {
        let name = `${element.FirstName} ${element.LastName}`
        recipients.push({
          id: element.user_id,
          value: name,
          label: name,
        })
      })
      store.dispatch('messages/setRecipients', {
        source: 0,
        recipients: recipients,
      })
    }
  },
  [types.SET_CHECKED](state, data) {
    console.log('Set Checked Start', {
      members: state.members,
      selected: state.selectedids,
      data: data,
    })
    if (state.members) {
      if (data.action === 'all') {
        // of those presented, set all as checked
        state.selectedids = []
        state.unselectedids = []
        state.isAllChecked = data.checked
        state.members.forEach((element) => {
          element.checked = data.checked
          if (data.checked) {
            state.selectedids.push({
              user_id: parseInt(element.user_id),
              FirstName: element.FirstName,
              LastName: element.LastName,
            })
          }
        })
      } else if (data.action === 'member') {
        // look for member presented in listing
        let found = state.members.find(
          (x) => parseInt(x.user_id) === parseInt(data.checked.user_id)
        )
        // if found, set the checked accordingly
        if (found) {
          found.checked = data.checked.checked
        }
        // now, look for member in the selected ids array
        found = null
        found = state.selectedids.find(
          (x) => parseInt(x.user_id) === parseInt(data.checked.user_id)
        )
        // if found and user unchecked, delete it
        if (found) {
          if (!data.checked.checked) {
            state.selectedids = state.selectedids.filter((x) => {
              return parseInt(x.user_id) !== parseInt(data.checked.user_id)
            })
            state.unselectedids.push({
              user_id: parseInt(data.checked.user_id),
            })
          }
        } else {
          // otherwise, add it to the selected ids array
          state.selectedids.push({
            user_id: parseInt(data.checked.user_id),
            FirstName: data.checked.FirstName,
            LastName: data.checked.LastName,
          })
        }
        // finally, see if all presented members are all checked (or not)
        // state.isAllChecked = true
        // state.members.forEach((element) => {
        //   if (element.checked === false) {
        //     state.isAllChecked = false
        //   }
        // })
      } else if (data.action === 'reset') {
        // resetting, clear all checked
        state.isAllChecked = false
        state.selectedids = []
        state.unselectedids = []
        state.members.forEach((element) => {
          element.checked = false
        })
      }
    }
    console.log('Set Checked End', {
      members: state.members,
      selected: state.selectedids,
      data: data,
    })
  },
  [types.SET_MEMBERS](state, data) {
    state.members = null
    if (data !== undefined && data !== null) {
      console.log('Selected Ids', state.selectedids)
      state.members = data.data
      state.members.forEach((element) => {
        // see if we have anything checked
        let isChecked = state.isAllChecked ? true : false
        if (state.selectedids) {
          if (state.selectedids.length > 0) {
            let found = state.selectedids.find(
              (x) => parseInt(x.user_id) === parseInt(element.user_id)
            )
            if (found) {
              isChecked = true
            }
          }
        }
        if (state.unselectedids) {
          if (state.unselectedids.length > 0) {
            let found = state.unselectedids.find(
              (x) => parseInt(x.user_id) === parseInt(element.user_id)
            )
            if (found) {
              isChecked = false
            }
          }
        }
        // we have a bunch of clean up to do...
        element.AboveZoneTime = parseFloat(element.AboveZoneTime)
        element.BelowZoneTime = parseFloat(element.BelowZoneTime)
        element.Calories = parseFloat(element.Calories)
        element.InAboveGoal = parseFloat(element.InAboveGoal)
        element.InAboveZoneTime = parseFloat(element.InAboveZoneTime)
        element.InZoneTime = parseFloat(element.InZoneTime)
        element.MinutesAboveZone = parseFloat(element.MinutesAboveZone)
        element.MinutesBelowZone = parseFloat(element.MinutesBelowZone)
        element.MinutesInZone = parseFloat(element.MinutesInZone)
        element.Percent = parseFloat(element.Percent)
        element.SessionCount = parseInt(element.SessionCount)
        element.TotalTime = parseFloat(element.TotalTime)
        element.starlevel = parseInt(element.starlevel)
        element.program_id = parseInt(element.program_id)
        element.unread_messages = parseInt(element.unread_messages)
        element.user_id = parseInt(element.user_id)
        element.isNew = element.isNew ? parseInt(element.isNew) : 0
        element.checked = isChecked // foundId !== null || state.isAllChecked ? true : false
        if (element.foodTracking !== null) {
          element.foodTracking = JSON.parse(element.foodTracking)
        }
        if (element.lastPhoto !== null) {
          element.lastPhoto = JSON.parse(element.lastPhoto)
        }
        if (element.measurements !== null) {
          let measurements = JSON.parse(element.measurements)
          element.measurements = []
          // need to get top 2 based upon sort on ID desc
          let sorted = globals.sortArray(measurements, 'id', 'desc')
          let cnt = 1
          sorted.forEach((item) => {
            if (cnt <= 2) {
              element.measurements.push(item)
            }
            cnt++
          })
        }
        if (element.sizemeasurements !== null) {
          let sizemeasurements = JSON.parse(element.sizemeasurements)
          element.sizemeasurements = []
          // need to get top 2 based upon sort on ID desc
          let sorted = globals.sortArray(sizemeasurements, 'id', 'desc')
          let cnt = 1
          sorted.forEach((item) => {
            if (cnt <= 2) {
              element.sizemeasurements.push(item)
            }
            cnt++
          })
        }
        if (element.targets !== null) {
          element.targets = JSON.parse(element.targets)
        }
        if (element.settargets !== null) {
          element.settargets = JSON.parse(element.settargets)
        }
        if (element.overallScore !== null) {
          element.challenge = JSON.parse(element.overallScore)
          if (element.challenge.progress) {
            element.challenge.progress.forEach((element) => {
              element.date = new Date(element.date)
            })
            globals.sortByDate(element.challenge.progress, 'date', 'desc')
            if (element.challenge.progress[0].progress) {
              element.overallScore = parseFloat(
                element.challenge.progress[0].progress
              )
            } else {
              element.overallScore = 0
            }
          }
        }
        if (element.Avatar === null) {
          element.Avatar = '/media/default_avatar_128.png'
        } else if (element.Avatar === '') {
          element.Avatar = '/media/default_avatar_128.png'
        }
      })
      // set up the pager
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
      state.summary.isChanged = false
    }
    console.log('Members', state.members)
  },
  [types.SET_MEMBER](state, data) {
    state.member = null
    console.log('Got Member', data)
    if (data !== undefined && data !== null) {
      state.member = data
      let found = state.members.find(
        (x) => parseInt(x.user_id) === parseInt(data.id)
      )
      if (found) {
        found.isNew = false
      }
    }
  },
  [types.UPDATE_MEMBER_DATA](state, data) {
    if (data !== undefined && data !== null) {
      console.log('Member Update', {
        current: state.member,
        update: data,
      })
      state.member.allowTextMessages = data.allowTextMessages
      state.member.dateOfBirth = data.dateOfBirth
      state.member.age = data.age
      state.member.gender = data.gender
      state.member.currentRole = data.currentRole
      state.member.currentRoleName = data.currentRoleName
      state.member.viewHeight = data.viewHeight
      state.member.viewWeight = data.viewWeight
      state.member.height = data.height
      state.member.weight = data.weight
    }
  },
  [types.SET_MEMBER_GOALS](state, data) {
    state.memberGoals = null
    state.memberDailyProgress = null
    console.log('Got Member Goals', data)
    if (data !== undefined && data !== null) {
      state.memberGoals = data
      state.memberDailyProgress = data
    }
  },
  [types.SET_MEMBER_DAILYPROGRESS](state, data) {
    state.memberDailyProgress = null
    let azureStorageUrl = 'https://nuvita.blob.core.windows.net/appimages/'
    if (data !== undefined && data !== null) {
      state.memberDailyProgress = data
      if (Array.isArray(state.memberDailyProgress.dailyProgress)) {
        state.memberDailyProgress.dailyProgress.forEach((element) => {
          element.checked = false
          if (element.ActivityIcon !== null) {
            element.ActivityIcon = `${azureStorageUrl}${element.ActivityIcon}`
          }
        })
      }
    }
    console.log('Got Member Daily Progress', state.memberDailyProgress)
  },
  [types.SET_MEMBER_DAILYPROGRESS_DATA](state, data) {
    switch (data.name) {
      case 'checked': {
        let found = state.memberDailyProgress.dailyProgress.find(
          (x) => parseInt(x.session_id) === parseInt(data.value.id)
        )
        if (found) {
          found.checked = data.value.checked
        }
        break
      }
    }
  },
  [types.SET_MEMBER_PROFILEHISTORY](state, data) {
    state.memberProfileHistory = null
    console.log('Got Member Profile History', data)
    if (data !== undefined && data !== null) {
      state.memberProfileHistory = data
    }
  },
  [types.SET_MEMBER_SESSION_HEARTRATES](state, data) {
    state.memberSessionHeartRates = []
    console.log('Got Member Session Heartrates', data)
    if (data !== undefined && data !== null) {
      state.memberSessionHeartRates = data
    }
  },
  [types.SET_MEMBER_SESSION_DETAIL](state, data) {
    state.memberSession = null
    console.log('Got Member Session Detail', data)
    if (data !== undefined && data !== null) {
      state.memberSession = data
      state.memberSession.session.PercentHR += '%'
    }
  },
  [types.SET_ZONE_PROFILE](state, data) {
    state.zoneProfile = null
    console.log('Got Zone Profile', data)
    if (data !== undefined && data !== null) {
      state.zoneProfile = data
    }
  },
  [types.SET_ZONE_PROFILE_HISTORY](state, data) {
    console.log('Got Zone Profile History', data)
    if (data !== undefined && data !== null) {
      if (state.zoneProfile) {
        state.zoneProfile.usercardioprograms = data
      }
    }
  },
  [types.REMOVE_PROFILE_HISTORY](state, data) {
    console.log('Removing Profile History', data)
    if (data !== undefined && data !== null) {
      state.zoneProfile.usercardioprograms =
        state.zoneProfile.usercardioprograms.filter(
          (x) => parseInt(x.id) !== parseInt(data)
        )
      console.log(
        'Programs after Removal',
        state.zoneProfile.usercardioprograms
      )
    }
  },
  [types.SET_CHALLENGE_STATS](state, data) {
    state.challengeStats = null
    console.log('Got Challenge Stats', data)
    if (data !== undefined && data !== null) {
      state.challengeStats = data
    }
  },
}
